const APPROVER_GROUP_NAMES = 'approver_group_names';
const MOBILE_COMMUNICATION_CHECK = 'Mobile Communications Check';
const TYPE_APPROVALS = 'Approvals';
const STAUS_PENDING = 'Pending';

export {
  APPROVER_GROUP_NAMES,
  MOBILE_COMMUNICATION_CHECK,
  TYPE_APPROVALS, STAUS_PENDING,
};
